import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { I502Form } from 'clickNgo/models/crud/forms/i502Form'
import { CrudStore } from 'core/types/crudStore'

import { PartnerServiceOptions } from '../configs'
import { mapPartnerFrom502Crud } from '../mapping/mapPartnerFrom502Crud'

type Params = {
  EntryId: number
  LegalWorkflowStatus: PartnerWorkflowStatus
  LegalApproverComment: string
}

export const updateLegalPartnerRequestStatus = (params: Params): Promise<Partial<IPartner>> => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'update-legal-partner')

  return source
    .update(PartnerServiceOptions.LEGAL_PARTNER, [params])
    .then(([result]: I502Form[]) => result && mapPartnerFrom502Crud(result))
}
